class ElementBuilder {

    constructor(type) {

        this.element = document.createElement(type);

    }

    withClass(className) {

        this.element.className = className;
        
        return this;

    }

    withID(idName) {

        this.element.id = idName;
        
        return this;

    }

    withTextContent(textContent) {

        this.element.textContent = textContent;
        
        return this;

    }

    withHTMLContent(htmlContent) {

        this.element.innerHTML = htmlContent;
        
        return this;

    }

    withHref(url) {

        this.element.href = url;
        
        return this;

    }

    withRel(rel) {

        this.element.rel = rel;
        
        return this;

    }

    withSrc(source) {

        this.element.src = source;
        
        return this;

    }

    withAlt(alt) {

        this.element.alt = alt;
        
        return this;

    }

    withStyle(styleBuilder) {

        styleBuilder.build(this.element);

        return this;

    }

    build() {

        return this.element;

    }

}

class ElementStyleBuilder {
    
    constructor() {

        this.styles = {};

    }

    withProperty(name, value) {

        this.styles[name] = value;

        return this;

    }

    build(element) {

        Object.assign(element.style, this.styles);

    }

}